if (!customElements.get("shop-the-look-drawer")) {
  class ShopTheLookDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }
      this.init();
    }

    init() {
      this.toggleState = false;
      this.panel = this.querySelector(".shop-the-look-drawer__blocks");

      if (!this.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }

      this.querySelector(".button--close").addEventListener("click", this.close.bind(this));
      this.querySelector(".shop-the-look-drawer__backdrop").addEventListener("click", this.close.bind(this));

      const drawerId = this.id;
      document
        .querySelectorAll(`[aria-controls="${drawerId}"].shop-the-look-drawer__trigger`)
        .forEach(element => {
          element.addEventListener("click", this.open.bind(this));
        });

      this.bindSwipeToClose();
      this.bindVariantToCtaHref();
    }

    bindVariantToCtaHref() {
      
      
      
      
      this.querySelectorAll(".shop-the-look-drawer__card").forEach(card => {
        const productCard = card.querySelector("product-card");
        const cta = card.querySelector(".shop-the-look-drawer__view-product");
        if (!productCard || !cta) return;
        const baseHref = cta.getAttribute("href") || "#";
        const baseUrl = baseHref.split("?")[0];

        const updateHref = () => {
          const variantInput = productCard.querySelector('input[name="id"]');
          const variantId = variantInput && variantInput.value;
          cta.setAttribute(
            "href",
            variantId ? `${baseUrl}?variant=${variantId}` : baseHref
          );
        };

        productCard.addEventListener("click", e => {
          if (e.target.closest(".variant-option-radio-input, .button--variant")) {
            
            
            setTimeout(updateHref, 0);
          }
        });

        
        
        updateHref();
      });
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      this.style.display = "";
      
      
      void this.offsetWidth;
      requestAnimationFrame(() => {
        this.classList.add("is--open");
      });
    }

    close() {
      this.toggleState = false;
      document.querySelector("body").classList.remove("overflow-hidden");
      this.classList.remove("is--open");
      this.toggleAriaExpanded();
      if (this.panel) {
        this.panel.style.transform = "";
        this.panel.style.transition = "";
      }
      
      
      const onEnd = e => {
        if (e.target !== this.panel || e.propertyName !== "transform") return;
        if (!this.classList.contains("is--open")) {
          this.style.display = "none";
        }
        this.panel.removeEventListener("transitionend", onEnd);
      };
      if (this.panel) {
        this.panel.addEventListener("transitionend", onEnd);
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target.closest("button").setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute("aria-expanded", true);
      } else {
        document
          .querySelectorAll(`[aria-controls="${this.id}"]`)
          .forEach(button => {
            button.setAttribute("aria-expanded", false);
          });
      }
    }

    bindSwipeToClose() {
      if (!this.panel) return;

      const handle = this.querySelector(".shop-the-look-drawer__handle");
      
      
      const target = handle || this.panel;

      let startY = 0;
      let lastY = 0;
      let lastTime = 0;
      let velocity = 0;
      let dragging = false;

      const onStart = e => {
        if (!this.classList.contains("is--open")) return;
        const touch = e.touches ? e.touches[0] : e;
        startY = touch.clientY;
        lastY = startY;
        lastTime = Date.now();
        velocity = 0;
        dragging = true;
        this.panel.style.transition = "none";
      };

      const onMove = e => {
        if (!dragging) return;
        const touch = e.touches ? e.touches[0] : e;
        const dy = touch.clientY - startY;
        if (dy <= 0) {
          this.panel.style.transform = "translateY(0)";
          return;
        }
        const now = Date.now();
        const dt = now - lastTime || 1;
        velocity = (touch.clientY - lastY) / dt;
        lastY = touch.clientY;
        lastTime = now;
        this.panel.style.transform = `translateY(${dy}px)`;
      };

      const onEnd = e => {
        if (!dragging) return;
        dragging = false;
        const touch = e.changedTouches ? e.changedTouches[0] : e;
        const dy = touch.clientY - startY;
        this.panel.style.transition = "";
        if (dy > 80 || velocity > 0.5) {
          this.close();
        } else {
          this.panel.style.transform = "";
        }
      };

      target.addEventListener("touchstart", onStart, { passive: true });
      target.addEventListener("touchmove", onMove, { passive: true });
      target.addEventListener("touchend", onEnd);
      target.addEventListener("touchcancel", onEnd);
    }
  }

  customElements.define("shop-the-look-drawer", ShopTheLookDrawer);
}
